import { render } from "./XlBtn.vue?vue&type=template&id=05f35069&scoped=true"
import script from "./XlBtn.vue?vue&type=script&lang=js"
export * from "./XlBtn.vue?vue&type=script&lang=js"

import "./XlBtn.vue?vue&type=style&index=0&id=05f35069&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f35069"]])

export default __exports__